export const EUR_HEADERS = [
  { text: 'IBAN', sortable: false, value: 'iban' },
  { text: 'BIC', sortable: false, value: 'bic' },
  { text: 'Currency', sortable: false, value: 'currency' },
  { text: '', value: 'actions', sortable: false }
]

export const GBP_HEADERS = [
  { text: 'Account Number', sortable: false, value: 'account_number' },
  { text: 'Sort Code', sortable: false, value: 'sort_code' },
  { text: 'Currency', sortable: false, value: 'currency' },
  { text: '', value: 'actions', sortable: false }
]

export const DROPDOWN_OPTIONS = ['Edit']
